// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1bmRZ","title":"AfterFrontImage_title__11srO"};